export default "__VITE_ASSET__BG__uyd$__"